// extracted by mini-css-extract-plugin
export default {"welcomeSectionContainer":"WelcomeSection_welcomeSectionContainer__HN0lb"};